<template>
  <div class="wire-transfer-form-wrapper">
    <Form ref="WireTransferForm" :model="value" :rules="formRules">
      <FormItem label="Account Name" prop="account_name">
        <Input v-model="value.account_name" class="k-input"/>
      </FormItem>
      <FormItem label="Bank Name" prop="bank_name">
        <Input v-model="value.bank_name" class="k-input"/>
      </FormItem>
      <FormItem label="Account Number" prop="account_number">
        <Input v-model="value.account_number" class="k-input" v-cardformat:formatCardNumber/>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      formRules: {
        account_name: [
          { required: true, message: 'The account name cannot be empty', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: 'The bank name cannot be empty', trigger: 'blur' }
        ],
        account_number: [
          { required: true, message: 'The account number cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleSubmit () {
      this.$refs.WireTransferForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>
